module.exports = __webpack_public_path__ + "img/UPLOAD.83c5a502.svg";